import { render } from "./GameCard.vue?vue&type=template&id=0a4667cf&scoped=true"
import script from "./GameCard.vue?vue&type=script&lang=js"
export * from "./GameCard.vue?vue&type=script&lang=js"

import "./GameCard.vue?vue&type=style&index=0&id=0a4667cf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a4667cf"

export default script